import NavigationPanel from './NavigationPanel.vue'

export default NavigationPanel;
